module.exports = __webpack_public_path__ + "static/media/cloud-fs.d1c4a20e.svg";